export const SET_ACTIVE_FORM = 'SET_ACTIVE_FORM'
export const INIT = 'INIT'

export const TRANSPORTER_ID = 'transporters'
export const SHIPPERS_ID = 'shippers'

export const GOOGLE_KEY = 'AIzaSyAFrjPIUpOX8HdA0R5n65waSRGeWh9WFZI'
export const LANG = 'ua'

//contacts
export const HEADER_TEL_NUM = '+38 044 394-85-04'
export const LINK_TEL_NUM = '+380443948504'
export const SOVTES_TEL = '+38 044 394 85 04'
export const SOVTES_EMAIL = 'office@sovtes.ua'
export const LINK_LINKEDIN = 'https://www.linkedin.com/company/sovtes'
export const LINK_YOUTUBE =
  'https://www.youtube.com/channel/UCSvpwLmWQtRIhtvArMLhNuQ'
export const LINK_FACEBOOK = 'https://www.facebook.com/sovtes.ua/'
